import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerService } from '../../../core/services/spinner.service';
import { Subscription } from 'rxjs';
import { PowerBiEmbedComponent } from '../../powerbi-embed/powerbi-embed.component';
import { ContentService } from '../services/content.service';
import { ContentPWBI, ContentPWBIResponse } from '../type/content';
import { ActivatedRoute } from '@angular/router';
import { DataLayerService } from '../../../core/services/data-layer.service';

@Component({
  selector: 'app-content-powerbi',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, PowerBiEmbedComponent],
  templateUrl: './content-powerbi.component.html',
  styleUrl: './content-powerbi.component.scss',
})
export class ContentPowerbiComponent implements OnDestroy {
  subscription: Subscription = new Subscription();
  contenData!: ContentPWBI;
  content!: string;
  embedUrl!: string;
  embedToken!: string;

  private screenName = '';

  constructor(
    private readonly _contentService: ContentService,
    private readonly _spinnerService: SpinnerService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _dataLayerService: DataLayerService
  ) {
    this.content = this._activatedRoute.snapshot.paramMap.get('content') ?? '';
    this.screenName = `content-powerbi:${this.content}`;
    this.getContent();
  }

  getContent(): void {
    this._spinnerService.show();
    const sub = this._contentService.getContentPowerBi(this.content).subscribe({
      next: (response) => {
        const contentResponse: ContentPWBIResponse = response;
        if (contentResponse && contentResponse.access) {
          this.contenData = contentResponse.access;
          this.embedToken = this.contenData.accessToken;
          this.embedUrl = this.contenData.embedUrl;
          this._dataLayerService.pushEventSubmit(
            this.screenName,
            'access-powerbi',
            'Accessed Power BI content',
            'content actions'
          );
        }
      },
      error: (err) => {
        this._dataLayerService.pushEventSubmitError(
          this.screenName,
          'access-powerbi',
          err?.status ?? 'unknown',
          'Error accessing Power BI content'
        );
        this._spinnerService.hide();
      },
      complete: () => {
        this._spinnerService.hide();
      },
    });
    this.subscription.add(sub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
